import React from "react";


function Footer() {
  return (
    <footer id="footer" class="footer d-md-block d-none">
        <div class="container-fluid">
<div class="row">
    <div class="col">
        <div class="footer__text text-start">
        </div>
    </div>
    <div class="col">
        <div class="footer__text text-center">
            <span>© 2025 D360</span>
        </div>
    </div>
    <div class="col">
        <div class="footer__text text-end">
                        </div>
    </div>
</div>
</div>
    </footer>
  );
}

export default Footer;


